// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"26afa290","453":"7d66b99e","732":"d491cfc6"}[chunkId] + ".chunk.js";
};